/**
 * Converts a number of days into milliseconds.
 *
 * @param {number} days - The number of days to be converted into milliseconds.
 * @return {number} The equivalent time in milliseconds.
 */
export function daysToMilliseconds(days: number): number {
  return days * 24 * hoursToMilliseconds(1);
}

export function hoursToMilliseconds(hours: number): number {
  return hours * minutesToMilliseconds(60);
}

export function minutesToMilliseconds(minutes: number): number {
  return minutes * 60 * 1000;
}
